import React, { createContext, useContext, useEffect, useState } from "react";
import { BASE_URL } from "../Apis/apiConfig";

const AccessContext = createContext();

// Provider
export const AccessProvider = ({ children }) => {
  const [hasAccess, setHasAccess] = useState(true);

 

  return (
    <AccessContext.Provider value={{ hasAccess }}>
      {children}
    </AccessContext.Provider>
  );
};

// Hook
export const useAccess = () => useContext(AccessContext);